/* 🤖 this file was generated by svg-to-ts*/
export const iconInfo: {
  name: 'info';
  data: string;
} = {
  name: 'info',
  data: `<svg width="16" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M8 16c4.411 0 8-3.589 8-8s-3.589-8-8-8-8 3.589-8 8 3.589 8 8 8zm0-2c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6zm.38-8.08c.12-.05.23-.12.33-.21.09-.1.16-.21.21-.33a.995.995 0 00-.21-1.09A.994.994 0 008 4a.994.994 0 00-1 1c0 .13.03.26.08.38s.12.23.21.33c.05.04.1.09.16.12.05.04.11.07.17.09a.949.949 0 00.76 0zM8 12a1 1 0 001-1V8a1 1 0 10-2 0v3a1 1 0 001 1z"/></svg>`,
};
